import * as angular from 'angular';
import * as _ from 'lodash';
import { Plant } from "../../models/navigation";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { apsCommands } from "../../shared/dto/aps.commands";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import ReportServiceName, { ReportService } from "../../services/reports/report.service";
import template from './editHotEndBonus.tpl.html';

let requires = [LoaderServiceName, NotifyServiceName, ReportServiceName];

export interface EditHotEndBonusParams {
  plant: Plant;
  productionDate: Date;
  hotEndBonusItem: apsViewModels.HotEndBonusItem;
}

export function openEditHotEndBonus(data: EditHotEndBonusParams,
  $modal: mm.foundation.modal): angular.IPromise<apsViewModels.HotEndBonusItem> {
  return $modal.open({
    template: template,
    controller: 'EditHotEndBonusCtrl as vm',
    resolve: {
      data: function () {
        return data;
      }
    }
  }).result;
}

interface EditHotEndBonus {
  shops: apsViewModels.ShopNavigation[];
  originalhotEndRecord: apsViewModels.HotEndBonusItem;
  hotEndBonusCommand: apsCommands.UpdateHotEndBonus;
  form: angular.IFormController;
  shopShiftText: string;
  maxTime: number;
  save(): void;
  cancel(): void;
  ProdHrsEarned(): number;
  PerformancePercent(): number;
  // BonusPercent(): number;
  WeightedAmount(): number;
  showHelp(helpScreen: string): void;
  toggleHelpWindow(): void;
  showHelpWindow: boolean;
  helpText: string;
}

export default angular.module('aps.controller.editHotEndBonus', requires)
  .controller('EditHotEndBonusCtrl', editHotEndBonus)
  .name;

function editHotEndBonus(
  reportService: ReportService,
  loaderService: LoaderService,
  notifyService: NotifyService,
  data: EditHotEndBonusParams,
  $modalInstance: mm.foundation.modalInstance): EditHotEndBonus {
  let vm = {} as EditHotEndBonus;

  vm.shopShiftText = 'Shop : ' + _.find(data.plant.shops, { id: data.hotEndBonusItem.shopId }).name + ' Shift : ' + data.hotEndBonusItem.shift; 
  vm.maxTime = calculateShiftDuration(data.hotEndBonusItem.productionDate, data.hotEndBonusItem.shiftTime);
  vm.save = save;
  vm.cancel = cancel;
  vm.ProdHrsEarned = ProdHrsEarned;
  vm.PerformancePercent = PerformancePercent;
  // vm.BonusPercent = BonusPercent;
  vm.WeightedAmount = WeightedAmount;
  vm.showHelp = null;
  vm.showHelpWindow = false;
  vm.helpText = null;
  vm.toggleHelpWindow = null;

  if (data.hotEndBonusItem) {
    vm.originalhotEndRecord = data.hotEndBonusItem;
    vm.hotEndBonusCommand = {
      id: data.hotEndBonusItem.id,
      plantId: data.hotEndBonusItem.plantId,
      shopId: data.hotEndBonusItem.shopId,
      jobRunId: data.hotEndBonusItem.jobRunId,
      productionDate: data.hotEndBonusItem.productionDate,
      shift: data.hotEndBonusItem.shift,
      jobChangeAllowance: data.hotEndBonusItem.jobChangeAllowance,
      startupAllowance: data.hotEndBonusItem.startupAllowance,
      production: data.hotEndBonusItem.production,
      totalTime: data.hotEndBonusItem.totalTime,
      bonusPercent: data.hotEndBonusItem.bonusPercent,
      performancePercent: data.hotEndBonusItem.performancePercent,
      productionHrsEarned: data.hotEndBonusItem.productionHrsEarned,
      weightedAmount: data.hotEndBonusItem.weightedAmount,
      hasBeenModified: true
    };
  }
  vm.toggleHelpWindow = (): void => {
    vm.showHelpWindow = !vm.showHelpWindow;
  }

  vm.showHelp = (): void => {
    vm.helpText = getHelpText();
    vm.toggleHelpWindow();
  }
  function getHelpText(): string {
    return ` 
    <div class="header">
     <u>Startup Allowance</u>
    </div>   
    <div class="row hotendBonusReport"
    <div>
      First Shift Operating Hours after Job Change
    </div>    
    <div>     
    <table cellpadding="1" cellspacing="1" class="history-t">
  <tr>
    <th>Allowance</th>
    <th>1</th>
    <th>2</th>
    <th>3</th>
    <th>4</th>
    <th>5</th>
    <th>6</th>
    <th>7</th>
    <th>8</th>
  </tr>
  <tr>
    <td>First Shift Allowance</td>
    <td>0.67</td>
    <td>1.11</td>
    <td>1.39</td>
    <td>1.58</td>
    <td>1.69</td>
    <td>1.78</td>
    <td>1.85</td>
    <td>1.91</td>
  </tr>
  <tr>
    <td>Second Shift Allowance</td>
    <td>1.30</td>
    <td>0.91</td>
    <td>0.68</td>
    <td>0.54</td>
    <td>0.47</td>
    <td>0.42</td>
    <td>0.38</td>
    <td>0.35</td>
  </tr>
  <tr>
    <td>Third Shift Allowance</td>
    <td>0.32</td>
    <td>0.30</td>
    <td>0.28</td>
    <td>0.26</td>
    <td>0.24</td>
    <td>0.22</td>
    <td>0.21</td>
    <td>0.20</td>
  </tr>
  <tr>
    <td>Fourth Shift Allowance</td>
    <td>0.17</td>
    <td>0.14</td>
    <td>0.11</td>
    <td>0.08</td>
    <td>0.06</td>
    <td>0.04</td>
    <td>0.02</td>
    <td>--</td>
  </tr>
</table>
</div>
</div>
      `;
  }
  return vm;

  function ProdHrsEarned() {
    var val = vm.originalhotEndRecord.standardGobsPerHour > 0 ? ((vm.hotEndBonusCommand.production / vm.originalhotEndRecord.standardGobsPerHour) + vm.hotEndBonusCommand.jobChangeAllowance + vm.hotEndBonusCommand.startupAllowance) : 0;
    return roundDecimal(val);
  }

  function PerformancePercent() {
    var val = vm.ProdHrsEarned() / (vm.hotEndBonusCommand.totalTime / (60 * (data.hotEndBonusItem.isDoubleMachine ? 2 :1))) * 100;
    return val ? val : 0;
  }

  // function BonusPercent() {
  //   return 0;
  //   // return vm.palletKpiCommand.heldPallets * vm.palletQuantity;
  // }

  function WeightedAmount() {
    var val = vm.originalhotEndRecord.bonusPercent * (vm.hotEndBonusCommand.totalTime / (60 * (data.hotEndBonusItem.isDoubleMachine ? 2 :1)));
    return roundDecimal(val);
  }


  function roundDecimal(value: number) {
    return (value && value >=0) ? Math.round(value * 100.0) / 100.0 : 0;
  }
  function isDST(date) {
    var january = new Date(date.getFullYear(), 0, 1);
    var july = new Date(date.getFullYear(), 6, 1);
    var standardTimezoneOffset = Math.max(january.getTimezoneOffset(), july.getTimezoneOffset());
    
    return date.getTimezoneOffset() < standardTimezoneOffset;
  }

  function calculateShiftDuration(shiftStart, shiftEnd) {
    // Convert string dates into Date objects
    var start = new Date(shiftStart);
    var end = new Date(shiftEnd);

    // Determine if the shift crosses midnight (next day)
    if (end < start) {
      end.setDate(end.getDate() + 1);
    }

    // Check if DST starts or ends during the shift
    var startIsDST = isDST(start);
    var endIsDST = isDST(end);
    var shiftDuration = (data.hotEndBonusItem.isDoubleMachine) ? 960 : 480;

    // If the shift spans a DST change
    if ((data.hotEndBonusItem.shift ==='3' || data.hotEndBonusItem.shift ==='N') && (startIsDST !== endIsDST)) {
      if (startIsDST) {
        // Shift crosses the end of DST (fall back), so add 1 hour
        shiftDuration += (60 * (data.hotEndBonusItem.isDoubleMachine ? 2 :1));
      } else {
        // Shift crosses the start of DST (spring forward), so subtract 1 hour
        shiftDuration -= (60 * (data.hotEndBonusItem.isDoubleMachine ? 2 :1));
      }
    }

    return shiftDuration;
  }

  function save(): void {
    if (vm.form.$invalid) {
      return;
    }

    vm.hotEndBonusCommand.productionHrsEarned = ProdHrsEarned();
    vm.hotEndBonusCommand.performancePercent = roundDecimal(PerformancePercent());
    vm.hotEndBonusCommand.weightedAmount = roundDecimal(WeightedAmount());
    loaderService.loadingPromise(
      reportService.updateHotEndBonus(vm.hotEndBonusCommand)
        // .then(() => setTimeout(() => {
        //   //do nothing
        //   loaderService.setAppLoading(true);
        //   $modalInstance.close({
        //     ...vm.originalhotEndRecord,
        //     ...vm.hotEndBonusCommand,
        //   })
        // }, 500))
        .then(() => {
          $modalInstance.close({
            ...vm.originalhotEndRecord,
            ...vm.hotEndBonusCommand,
          }), notifyService.handleApiErrors
        })
        );
  }

  function cancel(): void {
    $modalInstance.close();
  }

}


// WEBPACK FOOTER //
// ./src/app/controllers/reports/editHotEndBonus.controller.ts